// Import style font
import "./Font.css"
import { px2Rem } from './Mixins'

// Defined type for font
const TYPE = {
  base: 'HelveticaNeue',
  bold: 'HelveticaNeueBold',
  light: 'HelveticaNeueLight',
  logo: 'RockWell'
}

// Defined size for font
const SIZE = {
  xxxTiny: `${px2Rem(12)}`,
  xxTiny: `${px2Rem(14)}`,
  xTiny: `${px2Rem(16)}`,
  tiny: `${px2Rem(18)}`,
  xxxSmall: `${px2Rem(19)}`,
  xxSmall: `${px2Rem(23)}`,
  xSmall: `${px2Rem(24)}`,
  small: `${px2Rem(25)}`,
  base: `${px2Rem(28)}`,
  medium: `${px2Rem(30)}`,
  large: `${px2Rem(36)}`,
  xLarge: `${px2Rem(40)}`,
  xxLarge: `${px2Rem(43)}`,
  xxxLarge:`${px2Rem(48)}`
}

export default { TYPE, SIZE }



// WEBPACK FOOTER //
// ./src/themes/Typography.js